import api from './axiosApi'
import type { ProcessingResponse } from '@/api/productLists'

export interface Planogram {
  id: string // pog_id as string
  pog_id: number
  pog_no: string
  name: string
  pog_group: string | null
  department: string | null
  pog_type: string | null
  pog_set_type: string | null
  status: string | null
  sku_count: number
  pog_start_sales_date: string | null
  pog_stop_sales_date: string | null
  pog_deact_dt: string | null
}

export interface PlanogramSku {
  sku_number: string
  description: string | null
  in_sku_master: boolean
  pog_ids: number[]
  pog_qty: number | null
}

export interface PaginatedPlanogramsResponse {
  data: Planogram[]
  pagination: {
    skip: number
    limit: number
    total: number
    has_more: boolean
  }
}

export interface PlanogramSkusResponse {
  pog_ids: number[]
  data: PlanogramSku[]
}

export interface CreatePlanogramProductListRequest {
  pog_ids: number[]
  sku_numbers?: string[]
  name?: string
}

export async function searchPlanograms(params: {
  search?: string
  include_inactive?: boolean
  skip?: number
  limit?: number
}): Promise<PaginatedPlanogramsResponse> {
  const { search, include_inactive = false, limit = 50 } = params
  const response = await api.get<PaginatedPlanogramsResponse>('/planograms', {
    params: {
      search: search || undefined,
      include_inactive,
      limit,
    },
  })
  return response.data
}

export async function getPlanogramSkus(
  pogIds: number[]
): Promise<PlanogramSkusResponse> {
  const params = new URLSearchParams()
  pogIds.forEach(id => params.append('pog_id', String(id)))
  const response = await api.get<PlanogramSkusResponse>(
    `/planograms/skus?${params.toString()}`
  )
  return response.data
}

export async function createPlanogramProductList(
  payload: CreatePlanogramProductListRequest
): Promise<ProcessingResponse> {
  const response = await api.post<ProcessingResponse>(
    '/planograms/product-lists',
    payload
  )
  return response.data
}
